var key: any = '';

export const controlBlur = (ref: any) => {
  if (ref === null) return;
  if (ref.current === null) return;

  // setTimeout(() => {
  //     ref.current.blur();
  // }, 100);
};

export const controlCurrency = (ref: any) => {
  if (ref === null) return;
  if (ref.current === null) return;
  setTimeout(() => {
    const input: any = document.getElementById(ref);
    const selectionEnd = input.value.indexOf(',');
    input.setSelectionRange(selectionEnd, selectionEnd);
  }, 0);
};

export const valueChange = (value: any, ref: any) => {
  const input: any = document.getElementById(ref);
  const selectionEnd = input.value.indexOf(',');

  if (value.formattedValue === '0,00') {
    setTimeout(() => {
      input.setSelectionRange(selectionEnd, selectionEnd);
    }, 0);
  }

  if (value.formattedValue === '0' || !value || value.formattedValue === ',00' || value.formattedValue === ',0' || value.formattedValue === '0,') {
    return '0,00';
  } else {
    return value;
  }
};
